import { render, staticRenderFns } from "./DialogTariffChange.vue?vue&type=template&id=6f864a90&scoped=true&"
import script from "./DialogTariffChange.vue?vue&type=script&lang=js&"
export * from "./DialogTariffChange.vue?vue&type=script&lang=js&"
import style0 from "./DialogTariffChange.vue?vue&type=style&index=0&id=6f864a90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f864a90",
  null
  
)

/* custom blocks */
import block0 from "./DialogTariffChange.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./DialogTariffChange.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle})
